module.exports = __webpack_public_path__ + "static/img/Rory-Sloane.2108256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rory-Sloane.jpg
// module id = ufhp
// module chunks = 0